import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { ReservationsReportFilterForm } from 'src/app/shared/interfaces';

import { Constants } from '../../common';
import { DataWithPagination } from '../../interface';
import { Mapper } from '../mapper/mapper';
import { ReservationsReport } from '../model';
import { BaseAPI } from './base-api';

@Injectable({
  providedIn: 'root',
})
export class ReservationsReportApi {
  constructor(private baseAPI: BaseAPI, private mapper: Mapper) {}

  getReservationsReport(filter: ReservationsReportFilterForm): Observable<DataWithPagination<ReservationsReport[]>> {
    return this.baseAPI.post(Constants.GET_RESERVATIONS_REPORT_API_URL, filter).pipe(
      map((res) => {
        const data: DataWithPagination<ReservationsReport[]> = {
          data: this.mapper.fromListJson(ReservationsReport, res.items),
          count: res.count,
        };
        return data;
      })
    );
  }
}
